import { html } from 'lit';

// NDI's full logo stands on the pages outside the console, drawn by the design
// system's AuthLayout since R13 (pages/standalone-page.ts): the file with the
// black line for light grounds, the one with the white line for dark grounds.

/**
 * The NDI letters, cropped from the same file and used as a mask, so they draw
 * in the colour of the text around them instead of NDI's red. This is how the
 * logo appears inside the working app: small, grey, after "by".
 *
 * The mask is set here, not in tailwind.css: the client build imports every
 * url() in that stylesheet and cannot resolve a file served from static/.
 */
export const ndiMark = () =>
  html`<span
    class="ndi-mark"
    role="img"
    aria-label="NDI"
    style="-webkit-mask-image: url('/ndi-mark.png'); mask-image: url('/ndi-mark.png')"
  ></span>`;
